import { getCookie } from 'legacy/utilities/Auth';

export default function useInstanceId() {
	return getCookie('dmInstanceId');
}
